export function bookingTicketFilename(
    bookingId: number,
    format: string,
): string {
    return `ticket-${bookingId}-${format}.pdf`;
}
